import LocalizedStrings from 'localized-strings';

import { TeamMemberRole, TeamMemberStatus } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    filters: {
      all: 'All',
      [TeamMemberRole.Accountant]: 'Accountants',
      [TeamMemberRole.Admin]: 'Admins',
      [TeamMemberRole.Employee]: 'Employees',
      [TeamMemberStatus.Locked]: 'Revoked',
    },
  },
  fr: {
    filters: {
      all: 'Tout',
      [TeamMemberRole.Accountant]: 'Comptables',
      [TeamMemberRole.Admin]: 'Admins',
      [TeamMemberRole.Employee]: 'Employé·es',
      [TeamMemberStatus.Locked]: 'Révoqué·es',
    },
  },
});

export default locales;
